// eslint-disable-next-line import/prefer-default-export
export enum CompanyType {
  AGENCY = "agency",
  CARRIER = "carrier",
  CLIENT = "client",
  CONTRIBUTOR = "intervenant",
  LOGISTICIAN = "logistician",
  SUPPLIER = "supplier",
}
